//
// jBobe.widget.scroller
// ---------------------

define(function(require, exports, module) {
    'use strict';
    var $ = require('j'),
        _ = require('underscore');
    require('common/jbone.widget');

    module.exports = $.widget('scroller', {

        init: function(options) {
            this.options = options;
            this.$content = this.options.content || this.$el;

            this.setWrapperHeight();
            $(window).on('resize.scroller', _.bind(_.throttle(this.setWrapperHeight.bind(this), 50)));
        },

        /**
         * Calculate max height of the table
         * @return {Number}
         */
        getMaxHeight: function() {
            var maxHeight = 0,
                $rows = this.$content.find('tr'),
                numberOfRows = this.options.numberOfRows || 1;

            if ($rows.length > numberOfRows) {
                for (var i = 0; i < numberOfRows; i++) {
                    maxHeight += $rows[i].offsetHeight;
                }
            }

            return maxHeight;
        },

        /**
         * Set max height for table body wrapper
         */
        setWrapperHeight: function() {
            var maxHeight = this.getMaxHeight();

            maxHeight && this.$content.css({
                'overflow-y': 'auto',
                'maxHeight': maxHeight + 'px'
            });

            this.setHeadingWidth();
        },

        /**
         * Set width for table heading when scroll apears
         */
        setHeadingWidth: function() {
            var $heading = this.options.heading;

            $heading && $heading.css('width', this.$content.css('width'));
        },

        destroy: function() {
            $(window).off('.scroller');
            $.Widget.prototype.destroy.call(this);
        }

    });

});
